<template>
    <div>

        <div class="has-margins-075 has-margins-sides">

            <div class="field">
                <div class="field-label has-text-left">
                    <label for="filterTickets" class="label">Search {{ theAttendanceStyle }}s:</label>
                </div>
                <div class="field-body">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <input class="input" type="text" id="filterTickets" name="filterTickets" v-model=" filterInput ">
                        </div>
                        <div class="control">
                            <button type="button" class="button" @click=" () => {$modal.show('qr-code-reader')} " aria-label="QR Code Reader Option">
                                <span class="icon">
                                    <img :src=" $store.state.assetRoute + '/images/QR-Code-Reader-Icon.png' " alt="QR Code Reader Icon">
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div v-if=" !$isEmptyObject(filteredTickets) ">

            <div class="is-divider" :data-content="'Filtered '+theAttendanceStyle+'s'"></div>

            <table class="table is-fullwidth">

                <thead aria-label="Checkin Table">
                <tr>
                    <th>
                        Check-In / ID#
                    </th>
                    <th>
                        Attendee
                    </th>
                    <th class="is-hidden-mobile">
                        {{ theAttendanceStyle }}
                    </th>
                    <th><!-- BLANK ON PURPOSE --></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for=" ticket in filteredTickets "
                    :key=" ticket.id "
                    class="has-background-white"
                    :style="`background: linear-gradient(90deg, #cfcfcfcf 0%, #cfcfcfcf 40%, ${ticket.parent_ticket.color} 100%);${ ticket.checkin ? 'opacity: 0.6;' : '' }`"
                >
                    <td>
                        <label class="xero-checkbox">
                            <input @change=" checkinUser(ticket) " class="is-hidden" type="checkbox" name="check_in[]" :value=" ticket.id " :checked=" !!ticket.checkin " v-model=" ticket.checkin ">
                            <span></span>
                            {{ ticket.order.reference + '-' + ticket.id }}
                        </label>
                    </td>
                    <td>{{ ticket.holder ? (ticket.holder.name || ticket.holder.username) : (ticket.holder_name ||
                        ticket.holder_email) }}
                    </td>
                    <td class="is-hidden-mobile">{{ ticket.title }}</td>
                    <td>
                        <a class="has-text-black" :href=" $prepareRoute(routeTicketPage, {'-TICKET-ID-': ticket.id}) " target="_blank"><i class="far fa-eye" :aria-label="'click to view '+theAttendanceStyle+' details'"></i></a>
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="is-divider" :data-content="'All '+theAttendanceStyle+'s'"></div>
        </div>


        <table class="table is-fullwidth">
            <thead aria-label="Checkin Table">
            <tr>
                <th>
                    Check-In / ID#
                </th>
                <th>
                    Attendee
                </th>
                <th class="is-hidden-mobile">
                    {{ theAttendanceStyle }}
                </th>
                <th><!-- BLANK ON PURPOSE --></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for=" ticket in xTickets "
                :key=" ticket.id "
                class="has-background-white"
                :style="`background: linear-gradient(90deg, #ffffff 0%, #ffffff 40%, ${ticket.parent_ticket.color} 100%);${ ticket.checkin ? 'opacity: 0.6;' : '' }`"
            >
                <td>
                    <label class="xero-checkbox">
                        <input @change=" checkinUser(ticket) " class="is-hidden" type="checkbox" name="check_in[]" :value=" ticket.id " :checked=" !!ticket.checkin " v-model=" ticket.checkin ">
                        <span></span>
                        {{ ticket.order.reference + '-' + ticket.id }}
                    </label>
                </td>
                <td>{{ ticket.holder ? (ticket.holder.name || ticket.holder.username) : (ticket.holder_name ||
                    ticket.holder_email) }}
                </td>
                <td class="is-hidden-mobile">{{ ticket.title }}</td>
                <td>
                    <a class="has-text-black" :href=" $prepareRoute(routeTicketPage, {'-TICKET-ID-': ticket.id}) " target="_blank"><i class="far fa-eye" :aria-label="'click to view '+theAttendanceStyle+' details'"></i></a>
                </td>
            </tr>
            </tbody>

        </table>

        <div class="xerocraft-loading" v-show=" qrLoading ">
            <div>
                <p>
                    <img :src=" $store.state.assetRoute + '/images/loading.gif' " alt="Loading Icon">
                </p>
            </div>
        </div>
        <div class="xerocraft-check-wrapper xerocraft-success" v-show=" qrSuccess ">
            <section>
                <div :class=" successAnimation ? ' load-complete circle-loader' : 'circle-loader' ">
                    <div :class=" successAnimation ? 'checkmark draw' : 'checkmark draw is-hidden' "></div>
                </div>
            </section>
            <div class="title is-5 has-text-success">
                {{ qrTicket.holder ? (qrTicket.holder.name || qrTicket.holder.username) : (qrTicket.holder_name ||
                qrTicket.holder_email) }} Checked IN!
            </div>
            <div class="subtitle">
                {{ qrTicket.title }}
            </div>
            <div>
                <button class="button is-danger is-small" @click=" checkinUser(qrTicket, true) ">Undo?</button>
            </div>
        </div>
        <div class="xerocraft-check-wrapper xerocraft-error" v-show=" qrError ">
            <section>
                <div :class=" errorAnimation ? ' load-complete circle-loader' : 'circle-loader' ">
                    <div :class=" errorAnimation ? 'checkmark draw' : 'checkmark draw is-hidden' "></div>
                </div>
            </section>
            <div class="title is-5 has-text-danger">
                {{ qrTicket.holder ? (qrTicket.holder.name || qrTicket.holder.username) : (qrTicket.holder_name ||
                qrTicket.holder_email) }} Checked OUT!
            </div>
            <div class="subtitle">
                {{ qrTicket.title }}
            </div>
            <div>
                <button class="button is-success is-small" @click=" checkinUser(qrTicket, true) ">Undo?</button>
            </div>
        </div>

        <modal
            name="qr-code-reader"
            :adaptive="true"
            :width="'90%'"
            :height="'auto'">
            <div class="is-padded-1">
                <button type="button" class="delete" aria-label="close qr code reader window" @click=" () => {$modal.hide('qr-code-reader')} "></button>
                <h4 class="title is-4">Scan {{ theAttendanceStyle }} QR Codes</h4>
            </div>

            <qrcode-stream @decode=" onQRDecode "></qrcode-stream>
        </modal>
    </div>
</template>

<script>
    import {QrcodeStream} from 'vue-qrcode-reader'

    export default {
        name: 'Checkin-Page',
        props: {
            event: {
                type: Object,
                required: true
            },
            tickets: {
                type: Object,
                required: true
            },
            routeTicketPage: {
                type: String,
                required: true
            },
            routeCheckIn: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                xTickets: this.tickets,
                filterInput: '',
                channel: null,

                qrLoading: false,
                qrSuccess: false,
                successAnimation: false,
                qrError: false,
                errorAnimation: false,
                qrTicket: {}
            };
        },
        computed: {
            filteredTickets() {
                if (this.filterInput) {
                    let result = {}, key;

                    for (key in this.xTickets) {
                        if (this.xTickets[key] && this.xTickets[key].order.reference.includes(this.filterInput) ||
                            this.xTickets[key].holder_name.includes(this.filterInput) ||
                            this.xTickets[key].holder_email.includes(this.filterInput) ||
                            (this.xTickets[key].holder && this.xTickets[key].holder.username.includes(this.filterInput)) ||
                            (this.xTickets[key].id === this.filterInput)) {

                            result[key] = this.xTickets[key];
                        }
                    }

                    return result;
                } else {
                    return {};
                }
            },
            theAttendanceStyle: function() {
                if(this.event.attendance_style === 'rsvp') return 'RSVP'
                return this.event.attendance_style ? this.event.attendance_style.charAt(0).toUpperCase() + this.event.attendance_style.slice(1) : 'ticket';
            }
        },
        methods: {
            checkinUser: function (ticket, qrCode = false) {
                if (qrCode) this.qrLoading = true;

                this.$http.post(
                    this.$prepareRoute(this.routeCheckIn, {
                            '-ORDER-REF-': ticket.order.reference,
                            '-TICKET-ID-': ticket.id,
                        }
                    ), {
                        _token: this.$store.state.csrfToken
                    })
                    .then(response => {
                        this.$d('response');
                        this.$d(response);

                        if (qrCode) this.qrLoading = false;

                        if (response.data.hasErrors) {
                            this.$store.commit('errors', response.data.errors);
                        } else if (response.data.success === true) {
                            this.handleNewCheckIn(response.data);
                            if (qrCode) this.successfulQrCode(this.xTickets[response.data.ticket], response.data.status || false);
                        } else {
                            this.$store.commit('error', response.data.message);
                        }

                        this.loading = false;
                    })
                    .catch(error => {
                        if (qrCode) this.qrLoading = false;

                        this.$displayError(error);
                        this.loading = false;
                    });
            },
            handleNewCheckIn: function (data) {
                data = data.checkin_results || data;
                if (data.status === 'checked') {
                    this.xTickets[data.ticket].checkin = true;
                } else if (data.status === 'unchecked') {
                    this.xTickets[data.ticket].checkin = false;
                }
            },
            onQRDecode: function (data) {
                if (data) {
                    let [orderRef, ticketId] = data.split('-');
                    if (this.xTickets[ticketId]) {
                        this.checkinUser(this.xTickets[ticketId], true);

                    }
                }
            },
            successfulQrCode: function (ticket, inOrOut) {
                if (ticket) {
                    this.qrTicket = ticket;
                    if (inOrOut === 'checked') {
                        this.qrSuccess = true;
                        this.successAnimation = true;
                        setTimeout(() => {
                            this.qrSuccess = false;
                            this.successAnimation = false;
                        }, 3000);
                    } else if (inOrOut === 'unchecked') {
                        this.qrError = true;
                        this.errorAnimation = true;
                        setTimeout(() => {
                            this.qrError = false;
                            this.errorAnimation = false;
                        }, 3000);

                    }
                }
            },
        },
        mounted() {

            this.$echo.channel('event.checkin')
                .listen('CheckInEvent', (data) => {
                    this.$d('socket.io data', data);
                    this.handleNewCheckIn(data);
                })
        },
        components: {
            QrcodeStream,
        }

    }
</script>


<style scoped lang="scss">

    @use "sass:math";

    // Define vars we'll be using
    $brand-success: #5cb85c;
    $brand-danger: #ff3860;
    $loader-size: 8em;
    $check-height: math.div($loader-size,2);
    $check-width: math.div($check-height,2);
    $check-left: (math.div($loader-size,6) + math.div($loader-size,12));
    $check-thickness: 5px;
    $check-success-color: $brand-success;
    $check-danger-color: $brand-danger;

    .xerocraft-success {
        z-index: 1999;
        .circle-loader {
            border-left-color: $check-success-color;
        }
        .load-complete {
            border-color: $check-success-color;
        }
        .checkmark {
            &:after {
                border-right: $check-thickness solid $check-success-color;
                border-top: $check-thickness solid $check-success-color;
            }
        }
    }
    .xerocraft-error {
        .circle-loader {
            border-left-color: $check-danger-color;
        }
        .load-complete {
            border-color: $check-danger-color;
        }
        .checkmark {
            &:after {
                border-right: $check-thickness solid $check-danger-color;
                border-top: $check-thickness solid $check-danger-color;
            }
        }
    }


    .xerocraft-check-wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
        z-index: 999;

        & section {
            display: inline-block;
            margin: 0 auto;
        }


        .circle-loader {
            margin-bottom: math.div($loader-size,2);
            border: 1px solid rgba(0, 0, 0, 0.2);
            animation: loader-spin 1.2s infinite linear;
            position: relative;
            display: inline-block;
            vertical-align: top;
            border-radius: 50%;
            width: $loader-size;
            height: $loader-size;
        }

        .load-complete {
            -webkit-animation: none;
            animation: none;
            transition: border 500ms ease-out;
        }

        .checkmark {

            &.draw:after {
                animation-duration: 800ms;
                animation-timing-function: ease;
                animation-name: checkmark;
                transform: scaleX(-1) rotate(135deg);
            }

            &:after {
                opacity: 1;
                height: $check-height;
                width: $check-width;
                transform-origin: left top;
                content: '';
                left: $check-left;
                top: $check-height;
                position: absolute;
            }
        }
    }

    @keyframes loader-spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes checkmark {
        0% {
            height: 0;
            width: 0;
            opacity: 1;
        }
        20% {
            height: 0;
            width: $check-width;
            opacity: 1;
        }
        40% {
            height: $check-height;
            width: $check-width;
            opacity: 1;
        }
        100% {
            height: $check-height;
            width: $check-width;
            opacity: 1;
        }
    }

    .v--modal-overlay {
        z-index: 900 !important;
    }
</style>
